import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

    
const categorias = [
	{
		value: "1",
		label: "Experto en producto"
	},
	{
		value: "2",
		label: "Vacunación"
	},
	{
		value: "3",
		label: "Solution Selling"
	}
];


class Questions extends Component {
	constructor(props) {
		super(props);
		this.state = {
            category: "",
            level: "",
            levelcategory:"",
            levels: [],
            levelcategories: [],
			columnDefs: [
				{ headerName: "Categoria", field: "categoryname", width: "150" },
				{ headerName: "Nivel", field: "levelname", width: "150" },
				{ headerName: "Subcategoria", field: "levelcategoryname", width: "150" },
				{ headerName: "Pregunta", field: "question", width: "400" },
                { headerName: "Respuesta 1", field: "answer1", width: "300" },
                { headerName: "Respuesta 2", field: "answer2", width: "300" },
                { headerName: "Respuesta 3", field: "answer3", width: "300" },
                { headerName: "Respuesta 4", field: "answer4", width: "300" }
			]
		};
    }


	handleCreateQuestion = () => {
		this.setState({
			createNew: true
		});
    };
    
	handleCancel = () => {
		this.setState({
			createNew: false
		});
    };

    handleConfirm = () => {

        if(this.state.category &&
           this.state.level &&
           this.state.levelcategory &&
           this.state.question &&
           this.state.answer1 &&
           this.state.answer2)
        this.props.handleSaveQuestion({
            "category":this.state.category,
            "level":this.state.level,
            "levelcategory":this.state.levelcategory,
            "question":this.state.question,
            "answer1":this.state.answer1,
            "answer2":this.state.answer2,
            "answer3":this.state.answer3,
            "answer4":this.state.answer4,
            "iscorrect1":this.state.isCorrect1 ? 1 : 0,
            "iscorrect2":this.state.isCorrect2 ? 1 : 0,
            "iscorrect3":this.state.isCorrect3? 1 : 0,
            "iscorrect4":this.state.isCorrect4? 1 : 0
        });
        this.setState({
            createNew: false,
            category: "",
            level: "",
            levelcategory:"",
            question:"",
            answer1:"",
            answer2:"",
            answer3:"",
            answer4:"",
            isCorrect1: false,
            isCorrect2: false, 
            isCorrect3: false,
            isCorrect4 : false
		});
    }
    

    
	componentDidMount() {}

	render() {
		return (
			<React.Fragment>

            <Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.createNew}
				>
					<Paper
						style={{
							display: "grid",
							width: "70%",
							padding: "25px",
                            margin: "auto auto",
                            height: "90%",
                            overflowY: "auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Crear Nueva Pregunta
							<br />
                            <TextField
								id="standard-select"
								select
								label="Categoría"
								style={{
                                 
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.category}
								onChange={value =>{
                                    this.setState({ category: value.target.value });
                                    this.props.loadLevels(value.target.value);
                                    }
								}
							>
								{categorias.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
                            
                            <TextField
								id="standard-select"
								select
								label="Nivel"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.level}
								onChange={value => {
                                    this.props.loadLevelCategories(value.target.value);
									this.setState({ level: value.target.value })
                                }
                            }
							>
								{this.props.levels.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
                            <br />
                            <TextField
								id="standard-select"
								select
								label="Sub-Categoría"
								style={{
									marginBottom: "20px",
									width: "90%",
									textAlign: "left"
								}}
								value={this.state.levelcategory}
								onChange={value =>
									this.setState({ levelcategory: value.target.value })
								}
							>
								{this.props.levelCategories.map(option => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</TextField>
							<br />
							<TextField
								id="outlined-basic"
								label="Pregunta"
                                variant="outlined"
                                multiline
								value={this.state.question}
								onChange={value => this.setState({ question: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <br />
							<TextField
								id="outlined-basic"
								label="Respuesta 1"
								variant="outlined"
								multiline
								value={this.state.answer1}
								onChange={value => this.setState({ answer1: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={this.state.isCorrect1}
                                    onChange={event => this.setState({ isCorrect1: event.target.checked })} 
                                    label="Es Correcta?" 
                                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
                            <TextField
								id="outlined-basic"
								label="Respuesta 2"
								variant="outlined"
								multiline
								value={this.state.answer2}
								onChange={value => this.setState({ answer2: value.target.value })}
								style={{ width: "90%", textAlign: "left" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={this.state.isCorrect2}
                                    onChange={event => this.setState({ isCorrect2: event.target.checked })} 
                                    label="Es Correcta?" inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} 
                                    />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							<TextField
								id="outlined-basic"
								label="Respuesta 3"
								variant="outlined"
								multiline
								value={this.state.answer3}
								onChange={value => this.setState({ answer3: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                       
                                    <Checkbox 
                                        checked={this.state.isCorrect3}
                                        onChange={event => this.setState({ isCorrect3: event.target.checked })} 
                                        label="Es Correcta?" 
                                        inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
                            <TextField
								id="outlined-basic"
								label="Respuesta 4"
								variant="outlined"
								multiline
								value={this.state.answer4}
								onChange={value => this.setState({ answer4: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
                            <FormControlLabel
                                control={
                                    <Checkbox 
                                    checked={this.state.isCorrect4}
                                    onChange={event => this.setState({ isCorrect4: event.target.checked })} 
                                    label="Es Correcta?" 
                                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                                }
                                label="Es Correcta?"
                                style={{ width: "90%", textAlign:"left", alignItems:"left", justifyContent:"left" }}
                            />
                            <br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button onClick={this.handleCancel} color="primary">
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>


				<h2 style={{ width: "100%", textAlign: "left" }}>Preguntas</h2>
                <div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreateQuestion}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Agregar Pregunta
					</Button>
				</div>

				<div
					className="ag-theme-balham"
					style={{ height: "80vh", width: "100%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.questions}
					></AgGridReact>
				</div>
			</React.Fragment>
		);
	}
}

export default Questions;
